export const meta = {
  title: 'Agent codes & referrals: that code at signup, explained',
  updatedAt: '2026-07-17',
  related: ['getting-started', 'billing'],
};

The network has independent sales agents who introduce carwash operators. If one signed you up, you probably arrived through their link or QR code — or typed their code into the signup form. Here's exactly what that code did, and what it will never do.

## What the code does

An agent code attaches the agent to your account **at signup**. When you follow an agent's link, a banner shows the agent's name before you submit — you always know who's getting credit. Typed codes are checked too; an invalid code simply doesn't attach.

## What it costs you: nothing

Your subscription price is **identical with or without a code** — same plans, same trial, same invoices. The agent's commission is paid from the network's side; it is never added to your bill, and there is no such thing as an "agent surcharge".

## How the agent is paid — once

The model is deliberately simple: the agent earns a **one-time commission per signup**, equal to one month of your subscription, and it's triggered by your **first paid invoice**. After that, nothing — no ongoing percentage, no share of your future bills. If a trial never converts to a paid invoice, no commission is paid at all.

Some agents were themselves introduced by a recruiter; in that case the recruiter also earns a flat one-time amount for the signup. Same rules: once per signup, from the network's side, never from your pocket.

## Can I add a code later?

No — attribution is fixed at signup and can't be attached to an existing account afterwards. If an agent helped you and you're typing their code by hand, enter it before you submit the signup form.

## Becoming an agent

Anyone can join: the **Become an agent** page on this site takes two minutes. You get your code, share link, and a printable QR page immediately, and can start referring the same day. Earnings accrue in your agent dashboard as your operators pay their first invoices; payouts go out by DuitNow transfer, and require identity verification (KYC) first — you can earn before verifying, but not withdraw.
